import { BASE_DRIVER_COLUMNS } from '../TransportTableHeading/TransportTableHeading.tsx'
import LocalizedFileInput from 'components/Erp/LocalizedFileInput';
import { getLocale } from 'i18n';
import { tr } from 'i18n';
import VehicleNumberInput from 'components/Forms/VehicleNumberInput/VehicleNumberInput.tsx';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { SectionHeading, EmptyState } from 'components/Erp/Presentation';
import React, { useState } from 'react'
import ResponsiveTable from './ResponsiveTable'
import { MapPin, Map , Factory, Plus, Network, UsersRound, Truck, Pencil, Save, X, ChevronLeft, ChevronRight, FileText } from 'lucide-react'
import AuditButton from './AuditButton'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { hasAccess, canViewDrivers } from 'utils/access'
import DriverActions from './DriverActions'
import BaseDriverSummary from './BaseDriverSummary'
import BaseDriverDetails from './BaseDriverDetails'
import list from './DriverBaseList.module.scss'
import OperatorPinResetAction from './OperatorPinResetAction'
import OperatorInnChangeAction from './OperatorInnChangeAction'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import { DateTime, StatusBadge } from 'components/Erp/Display'
import styles from '../AdminPanelPage.module.scss'
import MiniMap from 'pages/ReportCard/MiniMap'
import BranchesList from './BranchesList'

const ChppsPanel = ({
  chppsFilter,
  setChppsFilter,
  filteredChpps,
  chppsPagination,
  loadChppsPage,
  openCreateModal,
  startEdit,
  editingChpp,
  editPayloads,
  setEditPayloads,
  saveEdit,
  cancelEdit,
  expandedChpp,
  setExpandedChpp,
  expandedOperatorsChpp,
  setExpandedOperatorsChpp,
  expandedDriversChpp,
  setExpandedDriversChpp,
  expandedBranchesChpp,
  setExpandedBranchesChpp,
  loadOperatorsByChppPage,
  loadDriversByChppPage,
  loadBranchesByChppPage,
  operatorsByChpp,
  driversByChpp,
  branchesByChpp,
  operatorsPaginationByChpp,
  driversPaginationByChpp,
  branchesPaginationByChpp,
  operatorsFilterByChpp,
  driversFilterByChpp,
  branchesFilterByChpp,
  setOperatorsFilterByChpp,
  setDriversFilterByChpp,
  setBranchesFilterByChpp,
  employees,
  editingOperatorByChpp,
  editingDriverByChpp,
  editingBranchByChpp,
  startEditOperator,
  startEditDriver,
  startEditBranch,
  saveEditOperator,
  saveEditDriver,
  saveEditBranch,
  cancelEditOperator,
  cancelEditDriver,
  cancelEditBranch,
  loadOperators,
  loadDriversByChpp,
  expandedDriverByChpp,
  toggleDriver,
  expandedOperatorByChpp,
  toggleOperatorChpp,
  printDriverPass,
  downloadDriverPass,
  chpps,
  topBases = [],
  privatePoints = []
}) => {
  useInterfaceLanguage();
  const currentUser=useSelector(state=>state.user)
  const driversVisible = canViewDrivers(currentUser)
  const [visibleMaps, setVisibleMaps] = useState({})
  return (
    <div className={styles.panel}>
      <SectionHeading icon={Factory} title={tr("ТЭЦ")} actions={<><div>
          <button className={styles.addButton} onClick={() => openCreateModal('chpp')}><Plus size={14} aria-hidden="true"/>{tr(" Добавить ТЭЦ")}</button>
        </div></>} />
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder={tr("Поиск...")} value={chppsFilter} onChange={(e) => setChppsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadChppsPage(1, chppsFilter) }} />
        </div>
        {filteredChpps && filteredChpps.length ? (
          <ResponsiveTable className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Название")}</th>
                <th>{tr("Телефон")}</th>
                <th>{tr("Местоположение")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredChpps.map((cp, index) => (
                <React.Fragment key={cp.id}>
                  <tr className={styles.topBaseRow}>
                    <td>{tr(index + 1)}</td>
                    <td className={styles.topBaseTitle} onClick={() => { const newVal = (expandedChpp === cp.id ? null : cp.id); setExpandedChpp(newVal); if (newVal) loadOperatorsByChppPage(cp.id, 1); }}>{tr(cp.name)}</td>
                    <td>{tr(cp.phone || '-')}</td>
                    <td>
                      {cp.geo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button
                              onClick={() => window.open(`https://www.google.com/maps?q=${cp.geo}`, '_blank')}
                              className={styles.geoLinkBtn}
                              title={tr("Открыть в Google Maps")}
                            >
                              <Map size={13}/>{tr(" Карты")}</button>
                            <button
                              onClick={() => setVisibleMaps(previous => ({ ...previous, [cp.id]: !previous[cp.id] }))}
                              aria-expanded={!!visibleMaps[cp.id]}
                              aria-controls={`map-chpp-${cp.id}`}
                              className={styles.mapToggleBtn}
                              title={tr("Показать/скрыть карту")}
                            >
                              <MapPin size={13}/>
                            </button>
                          </div>
                          <div id={`map-chpp-${cp.id}`} style={{ width: 200, height: 150, display: visibleMaps[cp.id] ? 'block' : 'none' }}>
                            <MiniMap geo={cp.geo} />
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td>
                      <div className={styles.actionGroup}>
                        <button aria-expanded={expandedChpp === cp.id && expandedBranchesChpp === cp.id} className={`${styles.smallBtn} ${expandedChpp === cp.id && expandedBranchesChpp === cp.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedBranchesChpp === cp.id ? null : cp.id); setExpandedBranchesChpp(newVal); if (newVal) loadBranchesByChppPage(cp.id, 1); setExpandedChpp(cp.id); }}><Network size={14} aria-hidden="true"/>{tr(" Филиалы")}</button>
                        <button aria-expanded={expandedChpp === cp.id && expandedOperatorsChpp === cp.id} className={`${styles.smallBtn} ${expandedChpp === cp.id && expandedOperatorsChpp === cp.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedOperatorsChpp === cp.id ? null : cp.id); setExpandedOperatorsChpp(newVal); if (newVal) loadOperatorsByChppPage(cp.id, 1); setExpandedChpp(cp.id); }}><UsersRound size={14} aria-hidden="true"/>{tr(" Операторы")}</button>
                        {tr(driversVisible && <button aria-expanded={expandedChpp === cp.id && expandedDriversChpp === cp.id} className={`${styles.smallBtn} ${expandedChpp === cp.id && expandedDriversChpp === cp.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedDriversChpp === cp.id ? null : cp.id); setExpandedDriversChpp(newVal); if (newVal) loadDriversByChppPage(cp.id, 1); setExpandedChpp(cp.id); }}><Truck size={14} aria-hidden="true"/>{tr(" Водители")}</button>)}
                        <button className={`${styles.smallBtn} ${styles.editBtn}`} onClick={() => startEdit('chpp', cp.id, { name: cp.name, phone: cp.phone })}><Pencil size={14} aria-hidden="true"/>{tr(" Изменить")}</button><AuditButton section="chpps" objectId={cp.id} objectType="tabel.CHPP"/>
                      </div>
                    </td>
                  </tr>
                  {tr(editingChpp === cp.id && (
                    <tr>
                      <td colSpan={5}>
                        <div style={{ padding: 8 }}>
                          <label>{tr("Название")}</label>
                          <input value={(editPayloads[`chpp__${cp.id}`] || {}).name || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp__${cp.id}`]: { ...p[`chpp__${cp.id}`], name: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                          <input value={(editPayloads[`chpp__${cp.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp__${cp.id}`]: { ...p[`chpp__${cp.id}`], phone: e.target.value } }))} />
                          <div style={{ marginTop: 8 }} className={styles.navbattons}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('chpp', cp.id)}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('chpp', cp.id)}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {tr(expandedChpp === cp.id && (
                    <tr>
                      <td colSpan={5}>
                        <div className={styles.operatorsList}>
                          {tr(expandedBranchesChpp === cp.id && (
                            <BranchesList
                              base={cp}
                              baseType="ТЭЦ"
                              branches={branchesByChpp[cp.id]}
                              branchesFilter={branchesFilterByChpp[cp.id]}
                              setBranchesFilter={(v) => setBranchesFilterByChpp(prev => ({ ...prev, [cp.id]: v }))}
                              loadBranchesByBasePage={loadBranchesByChppPage}
                              openCreateModal={openCreateModal}
                              editingBranch={editingBranchByChpp}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditBranch}
                              saveEdit={saveEditBranch}
                              cancelEdit={cancelEditBranch}
                              branchesPagination={branchesPaginationByChpp[cp.id]}
                            />
                          ))}

                          {tr(expandedOperatorsChpp === cp.id && (
                            <OperatorsForChpp
                              cp={cp}
                              operators={operatorsByChpp[cp.id]}
                              operatorsFilter={operatorsFilterByChpp[cp.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByChpp(prev => ({ ...prev, [cp.id]: v }))}
                              loadOperatorsByChppPage={loadOperatorsByChppPage}
                              employees={employees}
                              openCreateModal={openCreateModal}
                              editingOperatorByChpp={editingOperatorByChpp}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditOperator}
                              saveEdit={saveEditOperator}
                              cancelEdit={cancelEditOperator}
                              operatorsPagination={operatorsPaginationByChpp[cp.id]}
                              expandedOperatorByChpp={expandedOperatorByChpp}
                              toggleOperator={toggleOperatorChpp}
                            />
                          ))}

                          {tr(driversVisible && expandedDriversChpp === cp.id && (
                            <DriversForChpp
                              cp={cp}
                              drivers={driversByChpp[cp.id]}
                              driversFilter={driversFilterByChpp[cp.id]}
                              setDriversFilter={(v) => setDriversFilterByChpp(prev => ({ ...prev, [cp.id]: v }))}
                              loadDriversByChppPage={loadDriversByChppPage}
                              employees={employees}
                              editingDriverByChpp={editingDriverByChpp}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditDriver}
                              saveEdit={saveEditDriver}
                              openCreateModal={openCreateModal}
                              cancelEdit={cancelEditDriver}
                              driversPagination={driversPaginationByChpp[cp.id]}
                              expandedDriverByChpp={expandedDriverByChpp}
                              toggleDriver={toggleDriver}
                              printDriverPass={printDriverPass}
                              downloadDriverPass={downloadDriverPass}
                              chpps={chpps}
                              topBases={topBases}
                              privatePoints={privatePoints}
                            />
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </ResponsiveTable>
        ) : (
          <EmptyState icon={Factory} title={tr("ТЭЦ не найдены")} description={tr("Добавьте ТЭЦ или измените условия поиска.")} compact />
        )}
        {tr((!chppsFilter && chppsPagination && chppsPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!chppsPagination.previous} onClick={() => loadChppsPage((chppsPagination.page || 1) - 1)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
            <span>{tr("Стр. ")}{tr(chppsPagination.page || 1)}{tr(" — Всего: ")}{tr(chppsPagination.count)}</span>
            <button disabled={!chppsPagination.next} onClick={() => loadChppsPage((chppsPagination.page || 1) + 1)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
          </div>
        ))}
      </div>
    </div>
  )
}

// Inline components for operators and drivers to keep file self-contained; mimic TopBases versions but with chpp param
const OperatorsForChpp = ({ cp, operators = [], operatorsFilter = '', setOperatorsFilter = () => {}, openCreateModal, loadOperatorsByChppPage = () => {}, employees = [], editingOperatorByChpp = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, operatorsPagination = {},  expandedOperatorByChpp = {}, toggleOperator = () => {} }) => { useInterfaceLanguage(); return (<div style={{ marginTop: 12 }}>
    <div className={styles.subsectionHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <strong className={styles.subsectionTitle}><UsersRound size={17} aria-hidden="true"/>{tr(" Операторы этой ТЭЦ")}</strong>
      <div>
        <button className={`${styles.smallBtn} ${styles.addButton}`} onClick={() => openCreateModal('chpp-operator', { chpp: cp.id, chpp_name: cp.name })}><Plus size={14} aria-hidden="true"/>{tr(" Добавить оператора")}</button>
      </div>
    </div>
    <div style={{ marginTop: 8 }}>
      <div className={styles.searchRow}>
        <input className={styles.searchInput} placeholder={tr("Поиск...")} value={operatorsFilter || ''} onChange={(e) => setOperatorsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadOperatorsByChppPage(cp.id, 1, operatorsFilter || '') }} />
      </div>
      {(operators && operators.length) ? (
        <>
          <ResponsiveTable className={styles.table}>
            <thead>
              <tr>
                <th>{tr("ID")}</th>
                <th>{tr("Сотрудник")}</th>
                <th>{tr("Номер телефона")}</th>
                <th>{tr("Дополнительный ном.тел")}</th>
                <th>{tr("Создано")}</th>
                <th>{tr("Статус")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {operators.filter(op => {
                const q = (operatorsFilter || '').toLowerCase()
                if (!q) return true
                const emp = op.employee_name || String(op.employee)
                return (emp && emp.toLowerCase().includes(q)) || (op.phone && String(op.phone).toLowerCase().includes(q))
              }).map((op) => (
                <React.Fragment key={op.id}>
                  <tr style={{ cursor: 'pointer' }} onClick={() => toggleOperator(cp.id, op.id)}>
                    <td>{tr(op.id)}</td>
                    <td>{tr(op.employee_name || op.employee)}</td>
                    <td>{tr(op.employee_phone || '-')}</td>
                    <td>{tr(op.phone || '-')}</td>
                    <td><DateTime value={op.created_at}/></td>
                    <td><StatusBadge tone={op.is_active ? 'success' : 'danger'}>{op.is_active ? tr("Активен") : tr("Неактивен")}</StatusBadge></td>
                    <td>
                      <div className={styles.actionGroup}>
                        <button className={`${styles.smallBtn} ${styles.editBtn}`} onClick={(ev) => { ev.stopPropagation(); startEdit('chpp-operator', { chpp: cp.id, opId: op.id }, { phone: op.phone, is_active: op.is_active, employee: op.employee }) }}><Pencil size={14} aria-hidden="true"/>{tr(" Изменить")}</button><OperatorPinResetAction operator={op} onChanged={() => loadOperatorsByChppPage(cp.id, operatorsPagination.page || 1, operatorsFilter)} /><OperatorInnChangeAction operator={op} onChanged={() => loadOperatorsByChppPage(cp.id, operatorsPagination.page || 1, operatorsFilter)} /><AuditButton section="chpps" objectId={op.id} objectType="tabel.TopBaseOperator"/>
                      </div>
                    </td>
                  </tr>
                  {tr(expandedOperatorByChpp[cp.id] === op.id && (
                    <tr>
                      <td colSpan={7} style={{ textAlign: 'start', padding: 12 }}>
                        <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                          <div style={{ marginTop: 16, borderTop: "1px solid var(--theme-border, #e0e0e0)", paddingTop: 12 }}>
                            <strong>{tr("Документы оператора:")}</strong>
                            {op.documents && op.documents.length > 0 ? (
                              <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                                {op.documents.map(doc => (
                                  <li key={doc.id} style={{ marginBottom: 8 }}>
                                    <a href={doc.file_url} target="_blank" rel="noopener noreferrer" style={{ color: "var(--theme-primary-text, #0d00f3)", textDecoration: 'none' }}>
                                      {tr(doc.file_name)}
                                    </a>
                                    <span style={{ marginLeft: 8, color: "var(--theme-text-muted, #666)", fontSize: '12px' }}>
                                      ({(doc.file_size / 1024).toFixed(1)}{tr(" КБ) - ")}{new Date(doc.uploaded_at).toLocaleString(getLocale())}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <div style={{ marginTop: 8, color: "var(--theme-text-muted, #666)", fontStyle: 'italic' }}><EmptyState icon={FileText} title={tr("Нет документов")} compact /></div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {tr(editingOperatorByChpp[cp.id] === op.id && (
                    <tr>
                      <td colSpan={7}>
                        <div style={{ padding: 8 }}>
                          <label>{tr("Сотрудник")}</label>
                          <select value={(editPayloads[`chpp-operator_${cp.id}_${op.id}`] || {}).employee || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-operator_${cp.id}_${op.id}`]: { ...p[`chpp-operator_${cp.id}_${op.id}`], employee: Number(e.target.value) } }))}>
                            <option value="">{tr("— Выберите сотрудника —")}</option>
                            {employees.map(emp => (<option key={emp.id} value={emp.id}>{tr(emp.label)}</option>))}
                          </select>
                          <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                          <input value={(editPayloads[`chpp-operator_${cp.id}_${op.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-operator_${cp.id}_${op.id}`]: { ...p[`chpp-operator_${cp.id}_${op.id}`], phone: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Активен")}</label>
                          <input type="checkbox" checked={(editPayloads[`chpp-operator_${cp.id}_${op.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-operator_${cp.id}_${op.id}`]: { ...p[`chpp-operator_${cp.id}_${op.id}`], is_active: e.target.checked } }))} />

                          <div style={{ marginTop: 8 }}>
                            <label>{tr("Документы")}</label>
                            <LocalizedFileInput
                              type="file"
                              multiple
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                              onChange={(e) => {
                                const files = Array.from(e.target.files || [])
                                setEditPayloads(p => ({
                                  ...p,
                                  [`chpp-operator_${cp.id}_${op.id}`]: {
                                    ...p[`chpp-operator_${cp.id}_${op.id}`],
                                    newDocuments: files
                                  }
                                }))
                              }}
                            />
                            {tr(op.documents && op.documents.length > 0 && (
                              <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                <strong>{tr("Текущие документы:")}</strong>
                                <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                  {op.documents.map(doc => (
                                    <li key={doc.id}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                        {tr(doc.file_name)}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>

                          <div style={{ marginTop: 8 }}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('chpp-operator', { chpp: cp.id, opId: op.id })}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('chpp-operator', { chpp: cp.id })}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </ResponsiveTable>
          {tr((!operatorsFilter && operatorsPagination && operatorsPagination.count > 0) && (
            <div className={styles.pagination}>
              <button disabled={!operatorsPagination.previous} onClick={() => loadOperatorsByChppPage(cp.id, (operatorsPagination.page || 1) - 1)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
              <span>{tr("Стр. ")}{tr(operatorsPagination.page || 1)}{tr(" — Всего: ")}{tr(operatorsPagination.count)}</span>
              <button disabled={!operatorsPagination.next} onClick={() => loadOperatorsByChppPage(cp.id, (operatorsPagination.page || 1) + 1)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
            </div>
          ))}
        </>
      ) : (
        <div><EmptyState icon={UsersRound} title={tr("Операторы не найдены")} compact /></div>
      )}
    </div>
  </div>); }

const DriversForChpp = ({ cp, drivers = [], driversFilter = '', setDriversFilter = () => {}, openCreateModal, loadDriversByChppPage = () => {}, employees = [], editingDriverByChpp = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, driversPagination = {}, expandedDriverByChpp = {}, toggleDriver = () => {}, printDriverPass = () => {}, downloadDriverPass = () => {}, chpps = [], topBases = [], privatePoints = [] }) => {
  useInterfaceLanguage();
  const user=useSelector(state=>state.user)
  return (
  <div style={{ marginTop: 12 }}>
    <div className={styles.subsectionHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <strong className={styles.subsectionTitle}><Truck size={17} aria-hidden="true"/>{tr(" Водители этой ТЭЦ")}</strong>{tr(hasAccess(user,'drivers_edit') && <NavLink className={`${styles.smallBtn} ${styles.addButton}`} to={'/driver-register-admin/?destination=chpp:' + cp.id}><Plus size={14} aria-hidden="true"/>{tr(" Регистрация водителя")}</NavLink>)}
      <div>
        {tr(hasAccess(user,'drivers_edit') && <button className={`${styles.smallBtn} ${styles.addButton}`} onClick={() => openCreateModal('chpp-driver', { chpp: cp.id, chpp_name: cp.name })}><Plus size={14} aria-hidden="true"/>{tr(" Добавить водителя")}</button>)}
      </div>
    </div>
    <div style={{ marginTop: 8 }}>
      <div className={styles.searchRow}>
        <input className={styles.searchInput} placeholder={tr("Поиск...")} value={driversFilter || ''} onChange={(e) => setDriversFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadDriversByChppPage(cp.id, 1, driversFilter || '') }} />
      </div>
      {(drivers && drivers.length) ? (
        <>
          <ResponsiveTable className={`${styles.table} ${list.table}`}>
            <thead>
              <tr>{BASE_DRIVER_COLUMNS.map(label => <th key={label}>{tr(label)}</th>)}</tr>
            </thead>
            <tbody>
              {drivers.map(d => (
                <React.Fragment key={d.id}>
                  <BaseDriverSummary driver={d} expanded={expandedDriverByChpp[cp.id] === d.id}
                    editing={editingDriverByChpp?.[cp.id] === d.id} detailId={`base-driver-chpp-${cp.id}-${d.id}`}
                    onToggle={() => toggleDriver(cp.id, d.id)}
                    onEdit={hasAccess(user, 'drivers_edit') ? () => startEdit('chpp-driver', { chpp: cp.id, drId: d.id }, { employee: d.employee, chpp: d.chpp || cp.id, vehicle_number: d.vehicle_number, vehicle_model: d.vehicle_model, phone: d.phone, is_active: d.is_active }) : undefined} />
                  {tr(expandedDriverByChpp[cp.id] === d.id && (
                    <tr>
                      <td colSpan={6}>
                        <div id={`base-driver-chpp-${cp.id}-${d.id}`} className={list.expanded}>
                          <DriverActions driver={d} edit={false} onChanged={() => loadDriversByChppPage(cp.id, driversPagination.page || 1, driversFilter)} />
                          <BaseDriverDetails driver={d}
                            onPrint={() => printDriverPass(d, tr("ТЭЦ"), chpps.find(x => String(x.id) === String(d.chpp))?.name || cp.name || '')}
                            onDownload={() => downloadDriverPass(d, tr("ТЭЦ"), chpps.find(x => String(x.id) === String(d.chpp))?.name || cp.name || '')} />
                        </div>
                      </td>
                    </tr>
                  ))}
                  {tr(editingDriverByChpp[cp.id] === d.id && (
                    <tr>
                      <td colSpan={6}>
                        <div style={{ padding: 8 }}>
                          <p>{tr("Водитель")}: {tr(d.employee_name || "Без водителя")}</p>
                            <p>{tr("База")}: {tr(d.top_base_name || "Без базы")}</p>
                            <label style={{ marginLeft: 8 }}>{tr("Номер машины")}</label>
                          <VehicleNumberInput value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).vehicle_number || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], vehicle_number: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Модель")}</label>
                          <input value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).vehicle_model || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], vehicle_model: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                          <input value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], phone: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Активен")}</label>
                          <input type="checkbox" disabled={!hasAccess(user,'drivers_active')} aria-label={tr("Активность водителя")} checked={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], is_active: e.target.checked, actor_pin: '' } }))} />
                          {hasAccess(user, 'drivers_active') && !!(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).is_active !== !!d.is_active && (
                            <ActorPinField value={(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).actor_pin || ''}
                              onChange={pin => setEditPayloads(p => ({ ...p, [`chpp-driver_${cp.id}_${d.id}`]: { ...p[`chpp-driver_${cp.id}_${d.id}`], actor_pin: pin } }))} />
                          )}

                          <div style={{ marginTop: 8 }}>
                            <label>{tr("Документы")}</label>
                            <LocalizedFileInput
                              type="file"
                              multiple
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                              onChange={(e) => {
                                const files = Array.from(e.target.files || [])
                                setEditPayloads(p => ({
                                  ...p,
                                  [`chpp-driver_${cp.id}_${d.id}`]: {
                                    ...p[`chpp-driver_${cp.id}_${d.id}`],
                                    newDocuments: files
                                  }
                                }))
                              }}
                            />
                            {tr(d.documents && d.documents.length > 0 && (
                              <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                <strong>{tr("Текущие документы:")}</strong>
                                <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                  {d.documents.map(doc => (
                                    <li key={doc.id}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                        {tr(doc.file_name)}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>

                          <div style={{ marginTop: 8 }}>
                            <button className={styles.btn_pin} disabled={!!(editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).is_active !== !!d.is_active && !/^[0-9]{4}$/.test((editPayloads[`chpp-driver_${cp.id}_${d.id}`] || {}).actor_pin || '')} onClick={() => saveEdit('chpp-driver', { chpp: cp.id, drId: d.id })}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('chpp-driver', { chpp: cp.id })}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </ResponsiveTable>
          {tr((driversPagination && driversPagination.count > 0) && (
            <div className={styles.pagination}>
              <button disabled={!driversPagination.previous} onClick={() => loadDriversByChppPage(cp.id, (driversPagination.page || 1) - 1, driversFilter)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
              <span>{tr("Стр. ")}{tr(driversPagination.page || 1)}{tr(" из ")}{Math.ceil(driversPagination.count / 25)}{tr(" — Всего: ")}{tr(driversPagination.count)}</span>
              <button disabled={!driversPagination.next} onClick={() => loadDriversByChppPage(cp.id, (driversPagination.page || 1) + 1, driversFilter)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
            </div>
          ))}
        </>
      ) : (
        <div><EmptyState icon={Truck} title={tr("Водители на этой базе не найдены")} compact /></div>
      )}
    </div>
  </div>
)
}

export default ChppsPanel
